const isdCodes = [
  { id: '1', code: '93', country: 'Afghanistan' },
  { id: '2', code: '355', country: 'Albania' },
  { id: '3', code: '213', country: 'Algeria' },
  { id: '4', code: '376', country: 'Andorra' },
  { id: '5', code: '244', country: 'Angola' },
  { id: '6', code: '1-264', country: 'Anguilla' },
  { id: '7', code: '672', country: 'Antarctica' },
  { id: '8', code: '1-268', country: 'Antigua and Barbuda' },
  { id: '9', code: '54', country: 'Argentina' },
  { id: '10', code: '374', country: 'Armenia' },
  { id: '11', code: '297', country: 'Aruba' },
  { id: '12', code: '61', country: 'Australia' },
  { id: '13', code: '43', country: 'Austria' },
  { id: '14', code: '994', country: 'Azerbaijan' },
  { id: '15', code: '1-242', country: 'Bahamas' },
  { id: '16', code: '973', country: 'Bahrain' },
  { id: '17', code: '880', country: 'Bangladesh' },
  { id: '18', code: '1-246', country: 'Barbados' },
  { id: '19', code: '375', country: 'Belarus' },
  { id: '20', code: '32', country: 'Belgium' },
  { id: '21', code: '501', country: 'Belize' },
  { id: '22', code: '229', country: 'Benin' },
  { id: '23', code: '1-441', country: 'Bermuda' },
  { id: '24', code: '975', country: 'Bhutan' },
  { id: '25', code: '591', country: 'Bolivia' },
  { id: '26', code: '387', country: 'Bosnia and Herzegovina' },
  { id: '27', code: '267', country: 'Botswana' },
  { id: '28', code: '55', country: 'Brazil' },
  { id: '29', code: '246', country: 'British Indian Ocean Territory' },
  { id: '30', code: '1-284', country: 'British Virgin Islands' },
  { id: '31', code: '673', country: 'Brunei' },
  { id: '32', code: '359', country: 'Bulgaria' },
  { id: '33', code: '226', country: 'Burkina Faso' },
  { id: '34', code: '257', country: 'Burundi' },
  { id: '35', code: '855', country: 'Cambodia' },
  { id: '36', code: '237', country: 'Cameroon' },
  { id: '37', code: '1', country: 'Canada' },
  { id: '38', code: '238', country: 'Cape Verde' },
  { id: '39', code: '1-345', country: 'Cayman Islands' },
  { id: '40', code: '236', country: 'Central African Republic' },
  { id: '41', code: '235', country: 'Chad' },
  { id: '42', code: '56', country: 'Chile' },
  { id: '43', code: '86', country: 'China' },
  { id: '44', code: '61', country: 'Christmas Island' },
  { id: '45', code: '61', country: 'Cocos Islands' },
  { id: '46', code: '57', country: 'Colombia' },
  { id: '47', code: '269', country: 'Comoros' },
  { id: '48', code: '682', country: 'Cook Islands' },
  { id: '49', code: '506', country: 'Costa Rica' },
  { id: '50', code: '385', country: 'Croatia' },
  { id: '51', code: '53', country: 'Cuba' },
  { id: '52', code: '599', country: 'Curacao' },
  { id: '53', code: '357', country: 'Cyprus' },
  { id: '54', code: '420', country: 'Czech Republic' },
  { id: '55', code: '243', country: 'Democratic Republic of the Congo' },
  { id: '56', code: '45', country: 'Denmark' },
  { id: '57', code: '253', country: 'Djibouti' },
  { id: '58', code: '1-767', country: 'Dominica' },
  { id: '59', code: '1-809', country: 'Dominican Republic' },
  { id: '60', code: '670', country: 'East Timor' },
  { id: '61', code: '593', country: 'Ecuador' },
  { id: '62', code: '20', country: 'Egypt' },
  { id: '63', code: '503', country: 'El Salvador' },
  { id: '64', code: '240', country: 'Equatorial Guinea' },
  { id: '65', code: '291', country: 'Eritrea' },
  { id: '66', code: '372', country: 'Estonia' },
  { id: '67', code: '251', country: 'Ethiopia' },
  { id: '68', code: '500', country: 'Falkland Islands' },
  { id: '69', code: '298', country: 'Faroe Islands' },
  { id: '70', code: '679', country: 'Fiji' },
  { id: '71', code: '358', country: 'Finland' },
  { id: '72', code: '33', country: 'France' },
  { id: '73', code: '689', country: 'French Polynesia' },
  { id: '74', code: '241', country: 'Gabon' },
  { id: '75', code: '220', country: 'Gambia' },
  { id: '76', code: '995', country: 'Georgia' },
  { id: '77', code: '49', country: 'Germany' },
  { id: '78', code: '233', country: 'Ghana' },
  { id: '79', code: '350', country: 'Gibraltar' },
  { id: '80', code: '30', country: 'Greece' },
  { id: '81', code: '299', country: 'Greenland' },
  { id: '82', code: '1-473', country: 'Grenada' },
  { id: '83', code: '1-671', country: 'Guam' },
  { id: '84', code: '502', country: 'Guatemala' },
  { id: '85', code: '224', country: 'Guinea' },
  { id: '86', code: '245', country: 'Guinea-Bissau' },
  { id: '87', code: '592', country: 'Guyana' },
  { id: '88', code: '509', country: 'Haiti' },
  { id: '89', code: '504', country: 'Honduras' },
  { id: '90', code: '852', country: 'Hong Kong' },
  { id: '91', code: '36', country: 'Hungary' },
  { id: '92', code: '354', country: 'Iceland' },
  { id: '93', code: '91', country: 'India' },
  { id: '94', code: '62', country: 'Indonesia' },
  { id: '95', code: '98', country: 'Iran' },
  { id: '96', code: '964', country: 'Iraq' },
  { id: '97', code: '353', country: 'Ireland' },
  { id: '98', code: '44-1624', country: 'Isle of Man' },
  { id: '99', code: '972', country: 'Israel' },
  { id: '100', code: '39', country: 'Italy' },
  { id: '101', code: '225', country: 'Ivory Coast' },
  { id: '102', code: '1-876', country: 'Jamaica' },
  { id: '103', code: '81', country: 'Japan' },
  { id: '104', code: '44-1534', country: 'Jersey' },
  { id: '105', code: '962', country: 'Jordan' },
  { id: '106', code: '7', country: 'Kazakhstan' },
  { id: '107', code: '254', country: 'Kenya' },
  { id: '108', code: '686', country: 'Kiribati' },
  { id: '109', code: '383', country: 'Kosovo' },
  { id: '110', code: '965', country: 'Kuwait' },
  { id: '111', code: '996', country: 'Kyrgyzstan' },
  { id: '112', code: '856', country: 'Laos' },
  { id: '113', code: '371', country: 'Latvia' },
  { id: '114', code: '961', country: 'Lebanon' },
  { id: '115', code: '266', country: 'Lesotho' },
  { id: '116', code: '231', country: 'Liberia' },
  { id: '117', code: '218', country: 'Libya' },
  { id: '118', code: '423', country: 'Liechtenstein' },
  { id: '119', code: '370', country: 'Lithuania' },
  { id: '120', code: '352', country: 'Luxembourg' },
  { id: '121', code: '853', country: 'Macau' },
  { id: '122', code: '389', country: 'North Macedonia' },
  { id: '123', code: '261', country: 'Madagascar' },
  { id: '124', code: '265', country: 'Malawi' },
  { id: '125', code: '60', country: 'Malaysia' },
  { id: '126', code: '960', country: 'Maldives' },
  { id: '127', code: '223', country: 'Mali' },
  { id: '128', code: '356', country: 'Malta' },
  { id: '129', code: '692', country: 'Marshall Islands' },
  { id: '130', code: '222', country: 'Mauritania' },
  { id: '131', code: '230', country: 'Mauritius' },
  { id: '132', code: '262', country: 'Mayotte' },
  { id: '133', code: '52', country: 'Mexico' },
  { id: '134', code: '691', country: 'Micronesia' },
  { id: '135', code: '373', country: 'Moldova' },
  { id: '136', code: '377', country: 'Monaco' },
  { id: '137', code: '976', country: 'Mongolia' },
  { id: '138', code: '382', country: 'Montenegro' },
  { id: '139', code: '1-664', country: 'Montserrat' },
  { id: '140', code: '212', country: 'Morocco' },
  { id: '141', code: '258', country: 'Mozambique' },
  { id: '142', code: '95', country: 'Myanmar' },
  { id: '143', code: '264', country: 'Namibia' },
  { id: '144', code: '674', country: 'Nauru' },
  { id: '145', code: '977', country: 'Nepal' },
  { id: '146', code: '31', country: 'Netherlands' },
  { id: '147', code: '599', country: 'Netherlands Antilles' },
  { id: '148', code: '687', country: 'New Caledonia' },
  { id: '149', code: '64', country: 'New Zealand' },
  { id: '150', code: '505', country: 'Nicaragua' },
  { id: '151', code: '227', country: 'Niger' },
  { id: '152', code: '234', country: 'Nigeria' },
  { id: '153', code: '683', country: 'Niue' },
  { id: '154', code: '850', country: 'North Korea' },
  { id: '155', code: '47', country: 'Norway' },
  { id: '156', code: '968', country: 'Oman' },
  { id: '157', code: '92', country: 'Pakistan' },
  { id: '158', code: '680', country: 'Palau' },
  { id: '159', code: '970', country: 'Palestine' },
  { id: '160', code: '507', country: 'Panama' },
  { id: '161', code: '675', country: 'Papua New Guinea' },
  { id: '162', code: '595', country: 'Paraguay' },
  { id: '163', code: '51', country: 'Peru' },
  { id: '164', code: '63', country: 'Philippines' },
  { id: '165', code: '64', country: 'Pitcairn' },
  { id: '166', code: '48', country: 'Poland' },
  { id: '167', code: '351', country: 'Portugal' },
  { id: '168', code: '1-787', country: 'Puerto Rico' },
  { id: '169', code: '974', country: 'Qatar' },
  { id: '170', code: '242', country: 'Republic of the Congo' },
  { id: '171', code: '262', country: 'Reunion' },
  { id: '172', code: '40', country: 'Romania' },
  { id: '173', code: '7', country: 'Russia' },
  { id: '174', code: '250', country: 'Rwanda' },
  { id: '175', code: '590', country: 'Saint Barthelemy' },
  { id: '176', code: '290', country: 'Saint Helena' },
  { id: '177', code: '1-869', country: 'Saint Kitts and Nevis' },
  { id: '178', code: '1-758', country: 'Saint Lucia' },
  { id: '179', code: '590', country: 'Saint Martin' },
  { id: '180', code: '508', country: 'Saint Pierre and Miquelon' },
  { id: '181', code: '1-784', country: 'Saint Vincent and the Grenadines' },
  { id: '182', code: '685', country: 'Samoa' },
  { id: '183', code: '378', country: 'San Marino' },
  { id: '184', code: '239', country: 'Sao Tome and Principe' },
  { id: '185', code: '966', country: 'Saudi Arabia' },
  { id: '186', code: '221', country: 'Senegal' },
  { id: '187', code: '381', country: 'Serbia' },
  { id: '188', code: '248', country: 'Seychelles' },
  { id: '189', code: '232', country: 'Sierra Leone' },
  { id: '190', code: '65', country: 'Singapore' },
  { id: '191', code: '1-721', country: 'Sint Maarten' },
  { id: '192', code: '421', country: 'Slovakia' },
  { id: '193', code: '386', country: 'Slovenia' },
  { id: '194', code: '677', country: 'Solomon Islands' },
  { id: '195', code: '252', country: 'Somalia' },
  { id: '196', code: '27', country: 'South Africa' },
  { id: '197', code: '82', country: 'South Korea' },
  { id: '198', code: '211', country: 'South Sudan' },
  { id: '199', code: '34', country: 'Spain' },
  { id: '200', code: '94', country: 'Sri Lanka' },
  { id: '201', code: '249', country: 'Sudan' },
  { id: '202', code: '597', country: 'Suriname' },
  { id: '203', code: '47', country: 'Svalbard and Jan Mayen' },
  { id: '204', code: '268', country: 'Swaziland' },
  { id: '205', code: '46', country: 'Sweden' },
  { id: '206', code: '41', country: 'Switzerland' },
  { id: '207', code: '963', country: 'Syria' },
  { id: '208', code: '886', country: 'Taiwan' },
  { id: '209', code: '992', country: 'Tajikistan' },
  { id: '210', code: '255', country: 'Tanzania' },
  { id: '211', code: '66', country: 'Thailand' },
  { id: '212', code: '228', country: 'Togo' },
  { id: '213', code: '690', country: 'Tokelau' },
  { id: '214', code: '676', country: 'Tonga' },
  { id: '215', code: '1-868', country: 'Trinidad and Tobago' },
  { id: '216', code: '216', country: 'Tunisia' },
  { id: '217', code: '90', country: 'Turkey' },
  { id: '218', code: '993', country: 'Turkmenistan' },
  { id: '219', code: '1-649', country: 'Turks and Caicos Islands' },
  { id: '220', code: '688', country: 'Tuvalu' },
  { id: '221', code: '256', country: 'Uganda' },
  { id: '222', code: '380', country: 'Ukraine' },
  { id: '223', code: '971', country: 'United Arab Emirates' },
  { id: '224', code: '44', country: 'United Kingdom' },
  { id: '225', code: '1', country: 'United States' },
  { id: '226', code: '598', country: 'Uruguay' },
  { id: '227', code: '998', country: 'Uzbekistan' },
  { id: '228', code: '678', country: 'Vanuatu' },
  { id: '229', code: '379', country: 'Vatican' },
  { id: '230', code: '58', country: 'Venezuela' },
  { id: '231', code: '84', country: 'Vietnam' },
  { id: '232', code: '1-340', country: 'U.S. Virgin Islands' },
  { id: '233', code: '681', country: 'Wallis and Futuna' },
  { id: '234', code: '967', country: 'Yemen' },
  { id: '235', code: '260', country: 'Zambia' },
  { id: '236', code: '263', country: 'Zimbabwe' },
];

export default isdCodes;
